<template>
    <v-app>
        <!-- S: HEADER -->
        <header-primary v-if="$vuetify.breakpoint.xlOnly" />
        <template v-else>
            <mobile-header-primary />
            <mobile-nav-primary />
        </template>
        <!-- E: HEADER -->

        <!-- S: CONTENT -->
        <v-main id="main">
            <slot name="subHead" />
            <slot name="contentsHead" />
            <div id="contents">
                <slot />
            </div>
            <slot name="contentsFoot" />
        </v-main>
        <!-- E: CONTENT -->

        <!-- S: FOOTER -->
        <footer-primary />
        <!-- E: FOOTER -->

        <quick-primary v-if="$vuetify.breakpoint.xlOnly" />
        <btn-top-primary v-else />
    </v-app>
</template>

<script>
import HeaderPrimary from "@/sets/parents/headers/header-primary.vue";
import MobileHeaderPrimary from "@/sets/parents/headers/mobile-header-primary.vue";
import MobileNavPrimary from "@/sets/parents/headers/mobile-nav-primary.vue";
import FooterPrimary from "@/sets/parents/footers/footer-primary.vue";
import QuickPrimary from "@/sets/parents/quicks/quick-primary.vue";
import BtnTopPrimary from "@/components/publish/parents/buttons/btn-top-primary.vue";

export default {
    props: {
        isMain: { type: Boolean, default: true },
    },
    components: {
        HeaderPrimary,
        MobileHeaderPrimary,
        MobileNavPrimary,
        FooterPrimary,
        QuickPrimary,
        BtnTopPrimary,
    },
    mounted() {
        // 라우터 이동 시 스크롤 상단부터 시작
        window.scrollTo(0, 0);

        window.addEventListener("copy", this.preventCopy);
        window.addEventListener("contextmenu", this.preventCopy);
        window.addEventListener("selectstart", this.preventDefault);
        window.addEventListener("dragstart", this.preventDefault);

        this.init();
    },
    destroyed() {
        window.removeEventListener("copy", this.preventCopy);
        window.removeEventListener("contextmenu", this.preventCopy);
        window.removeEventListener("selectstart", this.preventDefault);
        window.removeEventListener("dragstart", this.preventDefault);
    },
    methods: {
        init: function () {
            setTimeout(() => {
                AOS.init({
                    once: true,
                    offset: 240,
                    duration: 800,
                    throttleDelay: 100,
                    easing: "ease-out",
                    anchorPlacement: "top-center",
                });
            }, 100);
        },
    },
};
</script>

<style lang="scss" scoped>
.app--main {
    ::v-deep {
        #contents {
            padding: 0;
        }
    }
}
</style>
